import AuctionOverView from "../auctionOverView";
import React from 'react'
import { useOutletContext } from "react-router-dom";
import OverViewShimmer from "./overViewShimmer";
import LiveAuctionOverview from "../liveAuctionOverview";

export default function Overview(){

    const outletContext = useOutletContext();
    const { auctionData,loading, loadLots } = outletContext;

    return(
        (loading || loadLots ||  Object.keys(auctionData).length==0) ? <OverViewShimmer /> : <div
            className="transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
            id="tabs-home3"
            role="tabpanel" 
            aria-labelledby="tabs-home-tab3">
            {auctionData?.auction_type=="live" ? <LiveAuctionOverview auctionData={auctionData} loading={loading}/> 
                : <AuctionOverView auctionData={auctionData} loading={loading} />}
        </div>
    );
}